import { useQuery } from '@tanstack/react-query';
import axiosInstance from '@/dataProvider/axios';
import { useAuthStoreV1 } from '@/stores/authStore_v1';
import { ORG_ROLES_ENDPOINT } from '@/services/org-admin';
import type { OrgRoleListResponse } from '@/services/org-admin';

export function useOrgRoles() {
  const orgId = useAuthStoreV1((s) => s.selectedOrg?.id ?? null);

  return useQuery({
    queryKey: ['org-roles', orgId],
    queryFn: async () => {
      const { data } = await axiosInstance.get<OrgRoleListResponse>(ORG_ROLES_ENDPOINT(orgId!));
      return data.roles;
    },
    enabled: !!orgId,
  });
}
